// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607291059/js/" + chunkId + "." + {"44":"43cd0385","225":"f004a2aa","481":"6dba7833","486":"951bfb15","770":"25755b3a"}[chunkId] + ".0.638715909815451.chunk.js";
};